// Google Authentication Configuration
export const GOOGLE_AUTH_CONFIG = {
  // Replace this with your actual Google OAuth Client ID
  // You can get this from: https://console.cloud.google.com/apis/credentials
  CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || 'your-google-client-id.apps.googleusercontent.com',
  
  // Google API Key for Picker API
  API_KEY: import.meta.env.VITE_GOOGLE_API_KEY || '',
  
  // Google Cloud Project Number (App ID) for Picker
  APP_ID: import.meta.env.VITE_GOOGLE_APP_ID || '',
  
  // Scopes for Google Drive access
  // drive.file - Only allows access to files opened/created by this app
  SCOPES: [
    'https://www.googleapis.com/auth/drive.file',
  ].join(' '),
};

// Add these to your .env file:
// VITE_GOOGLE_CLIENT_ID=your-actual-client-id.apps.googleusercontent.com
// VITE_GOOGLE_API_KEY=your-google-api-key
// VITE_GOOGLE_APP_ID=your-google-project-number
